var _radialGradient, _path, _radialGradient2, _path2, _linearGradient, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkypeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "u5YTW6YS6KxJF_jR8TBP1a",
    cx: 17.827,
    cy: 18.369,
    r: 13.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#007ec4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#00a0de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ade8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u5YTW6YS6KxJF_jR8TBP1a)",
    d: "M16,5C9.925,5,5,9.925,5,16s4.925,11,11,11s11-4.925,11-11S22.075,5,16,5z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "u5YTW6YS6KxJF_jR8TBP1b",
    cx: 28.168,
    cy: 33.743,
    r: 15.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.441,
    stopColor: "#0868b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581,
    stopColor: "#0770b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#0486c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a0d3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u5YTW6YS6KxJF_jR8TBP1b)",
    d: "M32,21c-6.075,0-11,4.925-11,11s4.925,11,11,11s11-4.925,11-11S38.075,21,32,21z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u5YTW6YS6KxJF_jR8TBP1c",
    x1: 11.272,
    x2: 36.728,
    y1: 11.272,
    y2: 36.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b3ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082d8"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u5YTW6YS6KxJF_jR8TBP1c)",
    d: "M24,6C14.059,6,6,14.059,6,24s8.059,18,18,18s18-8.059,18-18S33.941,6,24,6L24,6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.97,31.316c0-1.037,1.089-1.624,1.832-1.624s2.816,1.451,4.803,1.451 c1.054,0,3.421-0.103,3.421-2.29c0-3.585-10.115-3.308-10.115-9.274c0-1.038,0.285-5.795,7.784-5.795c2.016,0,5.71,0.577,5.71,2.493 c0,1.406-0.958,1.769-1.6,1.769c-1.244,0-1.745-1.123-4.285-1.123c-3.508,0-3.421,2.102-3.421,2.408 c0,3.017,10.073,3.017,10.073,9.255c0,6.141-7.491,5.814-8.58,5.814C21.474,34.4,16.97,33.856,16.97,31.316z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkypeIcon);
export default __webpack_public_path__ + "static/media/skype-icon.f64b6fba871dbdb64d3739c55171e743.svg";
export { ForwardRef as ReactComponent };